import React from 'react'
import {Switch, Route, Redirect} from 'react-router-dom'
import {MainPage} from './pages/MainPage'
import {CreatePage} from './pages/CreatePage'
import {DetailPage} from './pages/DetailPage'
import {AuthPage} from './pages/AuthPage'
import {SkillPage} from './pages/SkillPage'
import {PortfolioPage} from './pages/PortfolioPage'
import {BlogPage} from './pages/BlogPage'
import {AdminPage} from './pages/AdminPage'

export const useRoutes = isAuthenticated => {
    if (isAuthenticated){
        return (
            <Switch>

            <Route path="/" exact>
                <MainPage />
            </Route>
            <Route path="/auth" exact>
                <AuthPage />
            </Route>
            <Route path="/skill" exact>
                <SkillPage />
            </Route>
            <Route path="/portfolio" exact>
                <PortfolioPage />
            </Route>            
            <Redirect to="/" />
            
        </Switch>
        )
    }

    return (
        <Switch>
        <Route path="/" exact>
            <MainPage />
        </Route>
        <Route path="/admin" exact>
            <AdminPage />
        </Route>
        <Route path="/create" exact>
            <CreatePage />
        </Route>
        <Route path="/detail/:id" exact>
            <DetailPage />
        </Route>
        <Route path="/auth" exact>
            <AuthPage />
        </Route>
        <Route path="/skill" exact>
            <SkillPage />
        </Route>
        <Route path="/portfolio" exact>
            <PortfolioPage />
        </Route>
        <Route path="/blog" exact>
            <BlogPage />
        </Route>
        <Redirect to="/" />

    </Switch>
    )
}